// TODO: fix errors in CDS-114
export type UploadErrorCode = "unsupported" | "too-big";

export class UploadError extends Error {
  code: UploadErrorCode;

  constructor(code: UploadErrorCode) {
    super(`Upload Error (${code})`);
    this.code = code;
  }
}
